<template>
  <div id="modal_edit_news_trend" class="m-t-10">
    <form action="#" v-on:submit.prevent="updateData">
      <div class="form-group">
        <label for="input-nama">Judul</label>
        <div class="form-group">
          <input
            type="text"
            name="nama"
            value=""
            id="input-judul"
            class="form-control"
            placeholder="Judul"
            required
            v-model="judul"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-username">Deskripsi</label>
        <div class="form-group">
          <textarea
            class="form-control"
            id="content"
            name="content"
            rows="15"
            v-model="deskripsi"
          />
        </div>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary">Update</button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";

$.pgNotification = notif;

export default {
  name: "modal_add_news_trend",
  props: {
    data: String,
  },
  data() {
    return {
      judul: "",
      deskripsi: "",
      id_project: this.$store.getters.user.id_project,
    };
  },
  methods: {
    getEditData() {
      if (this.data != null) {
        let api = process.env.VUE_APP_API_URL + "/newstrend/desc/" + this.data;
        this.$http.get(api).then((response) => {
          if (response.status == 200) {
            (this.judul = response.data.title),
              (this.deskripsi = response.data.description);
          }
        });
      }
    },
    updateData() {
      let params = {
        _id: this.data,
        title: this.$sanitize(this.judul),
        description: this.$sanitize(this.deskripsi),
      };
      let api = process.env.VUE_APP_API_URL + "newstrend/desc/update";
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$parent.$parent.getData();
            $("#modalSlideUp").modal("hide");
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> News Trend berhasil diupdate!',
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch(() => {
          $("#modalSlideUp").modal("hide");
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan!',
              position: "top",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
  },
  created() {
    this.getEditData();
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
}
select {
  cursor: pointer;
}
</style>